import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadIssuerProfileLogoUrl,
  zadIssuerProfileUpdateUrl,
  zadIssuerProfileUrl,
} from '../../api'
import {parseZadApiError} from '../zad/errors'
import {extractZadIssuerProfile, sanitizeZadIssuerWritePayload} from '../zad/issuerHelpers'
import {UpdateZadIssuerProfileRequest, UploadZadIssuerLogoRequest} from './types'

export const fetchZadIssuerProfile = createAsyncThunk(
  'zadIssuerProfile/fetch',
  async (_payload: void, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadIssuerProfileUrl)
      return {
        success: true as const,
        profile: extractZadIssuerProfile(res.data) || {},
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadIssuerProfile = createAsyncThunk(
  'zadIssuerProfile/update',
  async (payload: UpdateZadIssuerProfileRequest, {rejectWithValue}) => {
    const body = sanitizeZadIssuerWritePayload(payload)
    try {
      const res = await axios.post(zadIssuerProfileUpdateUrl, body)
      return {
        success: true as const,
        profile: extractZadIssuerProfile(res.data) || body,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const uploadZadIssuerLogo = createAsyncThunk(
  'zadIssuerProfile/logo',
  async (payload: UploadZadIssuerLogoRequest, {rejectWithValue}) => {
    const data = new FormData()
    data.append('file', payload.file)
    try {
      const res = await axios.post(zadIssuerProfileLogoUrl, data, {
        headers: {'Content-Type': 'multipart/form-data'},
      })
      return {
        success: true as const,
        profile: extractZadIssuerProfile(res.data) || {},
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
